/* eslint-disable no-unused-vars */
import React,{useState} from 'react'
import PropTypes from 'prop-types'
import InfoIcon from "../../../../../../assets/images/InfoIcon.svg";
import './MSTNLoss.css'

function InfoWithHover({ label = "Info", description }) {
  const [show, setShow] = useState(false);

  if (!description) {
    return (
      <span className="info-wrapper" aria-hidden="true">
        <img src={InfoIcon} alt="Info" height="12" width="12" />
      </span>
    );
  }

   return (
    <button
      type="button"
      className="info-wrapperMSTN"
      aria-label={label}
      onMouseEnter={() => setShow(true)}
      onMouseLeave={() => setShow(false)}
      onFocus={() => setShow(true)}
      onBlur={() => setShow(false)}
    >
      <img src={InfoIcon} alt="Info" height="12" width="12" />
      {show && (
        <span className="ol-tooltipMSTN" role="tooltip">
          <span className="ol-tooltip-caretMSTN" />
          {description}
        </span>
      )}
    </button>
  );
}

InfoWithHover.propTypes = {
  label: PropTypes.string,
  description: PropTypes.string,
};

const UNIT_MAP = {
  Tonnes: "T",
  tonnes: "T",
  Eaches: "E",
  eaches: "E",
  Cases: "Cs",
  cases: "Cs",
  Value: "Rs",
  value: "Rs",
  Rs: "Rs",
};

const MSTNLoss = ({data}) => {
let totalRow=data.Total;
  const fullValueText = (val) =>
    typeof val === "number" ? val.toLocaleString("en-IN") : String(val ?? "");

  return (
    
              <div className="summarySectionMSTN">
            <div className="summaryLabelMSTN">
              <span>{totalRow?.name}</span>
              <InfoWithHover description={totalRow?.description} />
            </div>
            <div className="summaryMetricMSTN">
              <span
                className="summaryMetricValueMSTN valueEllipsisOlMSTN"
                title={fullValueText(totalRow?.value)}
                data-fullvalue={fullValueText(totalRow?.value)}
              >
                {totalRow?.value}
              </span>
              &nbsp;
              <span className="metricUnitMSTN">{UNIT_MAP[totalRow?.unit]}</span>
            </div>
          {/* <div className="lineSeparator"></div> */}

          </div>
  )
}

InfoWithHover.propTypes = {
  label: PropTypes.string,
  description: PropTypes.string,
};

export default MSTNLoss;

MSTNLoss.propTypes = {
  data: PropTypes.shape({
    Total: PropTypes.shape({
      name: PropTypes.string,
      description: PropTypes.string,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      unit: PropTypes.string,
    }),
  }),
};